import React from 'react';
import { Container, Grid, Card, Text, ThemeIcon, Stack, useMantineTheme } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { IconShield, IconRipple, IconPackages, IconMicroscope } from '@tabler/icons-react';
import { useAppSelector } from '../../store/hooks';
import { SectionTitle } from '../common/SectionTitle';

const qualityIcons: Record<string, any> = {
  gmp: IconShield,
  haccp: IconRipple,
  clean: IconPackages,
  hygiene: IconMicroscope,
};

const getIcon = (key: string) => qualityIcons[key] || IconShield;

export const OurQuality: React.FC = () => {
  const { content } = useAppSelector((state) => state.content);
  const { hygieneStandards } = content.pages.quality;

  const theme = useMantineTheme();
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);
  const isTablet = useMediaQuery(`(max-width: ${theme.breakpoints.md})`);

  const cardPadding = isMobile ? 'md' : 'xl';
  const iconSize = isMobile ? 50 : isTablet ? 70 : 80;
  const iconIconSize = isMobile ? 25 : isTablet ? 35 : 40;
  const titleSize = isMobile ? 'xs' : isTablet ? 'md' : 'lg';
  const descSize = isMobile ? 'xs' : 'sm';
  const gap = isMobile ? 'xs' : 'md';

  return (
    <Container size="xl" px={{ base: 0, sm: 'lg', md: 'xl' }}>
      <SectionTitle
        title={content.pages.home.sections.quality.title}
        subtitle={content.pages.home.sections.quality.description}
      />

      <Grid gutter={{ base: 'md', sm: 'lg', md: 'xl' }}>
        {hygieneStandards.map((standard) => {
          const IconComponent = getIcon(standard.icon);

          return (
            <Grid.Col key={standard.title} span={{ base: 6, sm: 6, md: 3 }}>
              <Card
                shadow="sm"
                padding={cardPadding}
                radius="lg"
                withBorder
                h="100%"
                className="quality-card"
              >
                <Stack align="center" gap={gap}>
                  <ThemeIcon size={iconSize} radius="xl" color="exportGreen" variant="light">
                    <IconComponent size={iconIconSize} stroke={1.5} />
                  </ThemeIcon>

                  <Text fw={600} size={titleSize} ta="center">
                    {standard.title}
                  </Text>

                  <Text ta="center" size={descSize} c="dimmed">
                    {standard.description}
                  </Text>
                </Stack>
              </Card>
            </Grid.Col>
          );
        })}
      </Grid>
    </Container>
  );
};